var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.996 8.896a1.171 1.171 0 00-.237-.615L1.813.49C1.506-.02.89-.153.436.191-.017.535-.137 1.227.17 1.737c.042.069.09.133.145.19L5.715 9l-5.4 7.073c-.4.419-.422 1.123-.049 1.573.373.45 1 .474 1.401.055a1.09 1.09 0 00.146-.19l5.946-7.792c.175-.227.26-.524.237-.823",
    opacity: 0.5
  })));
}
export default SvgRightArrow;